import { UrlWsInventarios } from '../config/Services'
import { DeleteCall, GetCall, PatchCall, PostCall, PutCall } from './_serviceHelper2'

const serviceUrl = UrlWsInventarios()

export const reportePoductosValorYStockPorCategoria = () => GetCall(serviceUrl + '/reportes/productosValorYStockPorCategoria')
export const reportePreciosObsoletos = () => GetCall(serviceUrl + '/reportes/preciosObsoletos')

/**
 * 
 * @param {Object} filtros campos de filtro: codigo, nombre, categoriaId, activo, soloStock, pageNumber, pageSize
 * @returns Array
 */
export const listarProductos = (filtros) => GetCall(serviceUrl, filtros)
export const autocompletarProducto = (texto) => GetCall(serviceUrl + '/autocompletar', {texto, activo: true})

export const agregarProducto = (unProducto) => PostCall(serviceUrl, unProducto)
export const editarProducto = (unProducto) => PutCall(serviceUrl, unProducto)
export const borrarProductos = (ids) => DeleteCall(serviceUrl, {ids})
export const reactivarProductos = (ids) => PatchCall(serviceUrl, {ids})
export const buscarSiguienteCodigoDisponible = () => GetCall(serviceUrl+'/codigoLibre', {})

//LOTES

export const listarLotes = (filtros) => {
    let auxFiltros = {...filtros, productoId: filtros?.producto?.id, producto: undefined}
    return GetCall(serviceUrl + '/lotes', auxFiltros)
}
export const agregarLote = (unLote) => PostCall(serviceUrl + '/lotes', unLote)
export const editarLote = (unLote) => PutCall(serviceUrl + '/lotes', unLote)
export const borrarLotes = (ids) => DeleteCall(serviceUrl + '/lotes', {ids})
export const reactivarLotes = (ids) => PatchCall(serviceUrl + '/lotes', {ids})